import React from 'react';

const QuestionMarkCircle = ({
  fillColor = 'primary',
  id = 'QuestionMarkCircle',
  className = '',
}) => {
  return (
    <svg
      id={id}
      className={`fill-${fillColor} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
    >
      <g clipPath="url(#clip0_425_4734)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42 21C42 26.5695 39.7875 31.911 35.8492 35.8492C31.911 39.7875 26.5695 42 21 42C15.4305 42 10.089 39.7875 6.15076 35.8492C2.21249 31.911 0 26.5695 0 21C0 15.4305 2.21249 10.089 6.15076 6.15076C10.089 2.21249 15.4305 0 21 0C26.5695 0 31.911 2.21249 35.8492 6.15076C39.7875 10.089 42 15.4305 42 21ZM14.427 15.8366C14.3424 15.8378 14.2584 15.8216 14.1803 15.7892C14.1021 15.7568 14.0314 15.7088 13.9724 15.6481C13.9134 15.5874 13.8674 15.5153 13.8373 15.4363C13.8071 15.3572 13.7934 15.2728 13.797 15.1882C14.0437 10.7389 17.6846 9.1875 21.0131 9.1875C24.6776 9.1875 28.0271 11.1037 28.0271 15.0675C28.0271 17.9025 26.3602 19.2517 24.7616 20.4671C22.827 21.9345 22.1104 22.4831 22.1104 24.3679V24.6435C22.1104 24.8175 22.0412 24.9845 21.9182 25.1075C21.7951 25.2306 21.6282 25.2997 21.4541 25.2997H19.3279C19.1556 25.2998 18.9903 25.2321 18.8675 25.1113C18.7447 24.9905 18.6744 24.8262 18.6716 24.654L18.6611 24.0844C18.5614 21.651 19.9605 20.1521 21.7271 18.8685C23.2759 17.703 24.2602 16.9365 24.2602 15.2696C24.2602 13.104 22.6117 12.2036 20.811 12.2036C18.7031 12.2036 17.5219 13.4584 17.2882 15.1804C17.241 15.54 16.9522 15.8366 16.59 15.8366H14.4244H14.427ZM20.5301 32.7495C18.9971 32.7495 17.8815 31.7153 17.8815 30.3161C17.8815 28.8671 18.9971 27.8486 20.5327 27.8486C22.1314 27.8486 23.2313 28.8671 23.2313 30.3161C23.2313 31.7153 22.1287 32.7495 20.5301 32.7495Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_425_4734">
          <rect width="42" height="42" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QuestionMarkCircle;
